





































































































































































































































































































import Vue from 'vue';

import { iconsMixin } from '@/mixins/icons';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { authMixin } from '@/mixins/auth';
import { formatMixin } from '@/mixins/format';

import localStorageService from '@/services/LocalStorageService';
import carrierService from '@/services/CarrierService';
import domService from '@/services/DOMService';
import miscService from '@/services/MiscService';

import { Carrier } from '@/models/carriers/Carrier';
import { ClientCarrierNetwork } from '@/models/carriers/ClientCarrierNetwork';
import SaveClientCarrierNetworkRequest from '@/models/requests/SaveClientCarrierNetworkRequest';

export default Vue.extend<any, any, any, any>({
  mixins: [iconsMixin, breakpointsMixin, authMixin, formatMixin],
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      term: '',
      networkName: '',
      selectedCarriers: [] as Carrier[],
      loading: false,
      confirmCancel: false,
      saving: false,
      snackbar: false,
      snackbarText: '',
      loadingMessage: '',
      all: [] as Carrier[],
      page: [] as Carrier[],
      filtered: [] as Carrier[],
      contractsHeaders: [
        {
          text: '',
          value: 'id',
          sortable: false,
          width: '2%',
        },
        {
          text: 'Carrier Name',
          value: 'name',
          sortable: false,
          width: '15%',
        },
        {
          text: 'Contact Name',
          value: 'contactName',
          sortable: false,
          width: '12%',
        },
        {
          text: 'Contact Email',
          value: 'contactEmail',
          sortable: false,
          width: '15%',
        },
        {
          text: 'Contact Phone',
          value: 'contactPhone',
          sortable: false,
          width: '10%',
        },
        {
          text: 'Equipement Type',
          value: 'eq',
          sortable: false,
        },
      ],
      displayPopup: false,
      refPrefix: 'contract_',
      networkToEdit: null as ClientCarrierNetwork, // in case of edit
      carrierIds: [] as number[], // in case of edit
      tableKey: 0,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loadingMessage = 'Loading details';
      this.loading = true;

      const availableCarriers = carrierService
        .getAllActive()
        .then((x: Carrier[]) => {
          this.all = x.filter((p) => p.name?.length);

          this.applyFilters();
          this.loading = false;
        });

      const clientNetwork = carrierService
        .getClientCarrierNetworks(this.client?.id)
        .then((x) => {
          this.clientNetworks = x;
        });

      const networkCarrierIds = carrierService
        .getNetworkCarrierIds(this.$route.params.id)
        .then((x) => {
          this.carrierIds = x;
        });

      Promise.all([availableCarriers, clientNetwork, networkCarrierIds]).then(
        () => {
          if (this.isEdit) {
            this.setFieldsForEdit();
          }
        }
      );
    },
    /* istanbul ignore next */
    setFieldsForEdit() {
      this.networkToEdit = this.clientNetworks.find(
        (x) => x.id == this.$route.params.id
      );
      if (this.networkToEdit) {
        this.networkName = this.networkToEdit.name;

        this.selectedCarriers = this.all.filter((x: Carrier) =>
          this.carrierIds.includes(x.mapId)
        );

        // update v-model / checkboxes
        this.all = this.all.map((y) => {
          if (this.selectedCarriers.some((x) => x.mapId === y.mapId)) {
            return { ...y, selected: true };
          } else {
            return y;
          }
        });

        this.filtered = this.filtered.map((y) => {
          if (this.selectedCarriers.some((x) => x.mapId === y.mapId)) {
            return { ...y, selected: true };
          } else {
            return y;
          }
        });

        this.page = this.page.map((y) => {
          if (this.selectedCarriers.some((x) => x.mapId === y.mapId)) {
            return { ...y, selected: true };
          } else {
            return y;
          }
        });

        this.tableKey += 1;
      }
    },
    clearSelectedCarriers() {
      this.selectedCarriers = [];

      this.all.forEach((x) => {
        x.selected = false;
      });
      this.filtered.forEach((x) => {
        x.selected = false;
      });
      this.page.forEach((x) => {
        x.selected = false;
      });
    },
    onClear() {
      this.term = '';
      this.applyFilters();
    },
    getRefName(id) {
      return this.refNames.find((x) => x.includes(id));
    },
    getContactName(carrier) {
      if (carrier?.contacts?.length) {
        return carrier.contacts[0].contactName;
      }

      return 'Not Available';
    },
    onCarrierSelect(item) {
      const index = this.selectedCarriers.findIndex((x) => x.id === item.id);
      if (index > -1) {
        this.selectedCarriers.splice(index, 1);
      } else {
        this.selectedCarriers.push(item);
      }
    },
    getContactEmail(carrier) {
      if (carrier?.contacts?.length) {
        return carrier.contacts[0].email?.split(';')[0].replace('.fake', '');
      }

      return 'Not Available';
    },
    getContactPhone(carrier) {
      if (carrier?.contacts?.length) {
        if (!carrier.contacts[0].contactPhone?.trim().length)
          return 'Not Available';

        return this.formatPhone(carrier.contacts[0].contactPhone?.trim());
      }

      return 'Not Available';
    },
    showConfirm() {
      this.displayPopup = true;
    },
    backTo() {
      miscService.goBack();
    },
    submitForm() {
      if (!this.formValid) return;

      const request = new SaveClientCarrierNetworkRequest();
      request.id = null;
      if (this.isEdit) {
        request.id = this.$route.params.id;
      }
      request.accountId = this.client.id;
      request.carrierIds = this.selectedCarriers.map((x) => x.mapId);
      request.name = this.networkName;

      this.saving = true;
      carrierService
        .saveClientCarrierNetwork(request)
        .then(this.handleSubmitFormResponse);
    },
    handleSubmitFormResponse(x) {
      this.saving = false;
      this.displayPopup = false;
      if (!x) {
        this.snackbar = true;
        this.snackbarText = 'Error saving spot market client-carrier network';
      } else {
        this.snackbar = true;
        this.snackbarText =
          'Spot market client-carrier network saved successfully';

        miscService.goBackWithDelay(2500);
      }
    },
    clearFilters() {
      this.term = '';
      this.applyFilters();
    },
    applyFilters() {
      let items = this.all;

      if (this.term) {
        items = items.filter((x) =>
          x.name.toLowerCase().includes(this.term.toLowerCase())
        );
      }

      this.filtered = items;
      this.page = items.slice(0, this.pageSize);
      this.currentPage = 1;
    },
    pageChange(newPage) {
      let page = this.all.slice(
        (newPage - 1) * this.pageSize,
        newPage * this.pageSize
      );
      this.page = page;
    },
  },
  computed: {
    refNames() {
      return this.all.map((item) => `${this.refPrefix}${item.contractId}`);
    },
    client() {
      return localStorageService.get('selected-afs-client');
    },
    emptyFields() {
      const emptyFields = [];

      if (!this.networkName) emptyFields.push('Network Name field is required');

      if (!this.selectedCarriers.length)
        emptyFields.push('Select at least one carrier from the carriers list');

      return emptyFields.join(', ');
    },
    formValid() {
      return !this.emptyFields;
    },
    isEdit() {
      return this.$route.params.id && domService.href().includes('edit');
    },
    pageHeader() {
      if (this.isEdit) {
        return 'Update Existing Spot Market Client-Carrier Network';
      }

      /* istanbul ignore next */
      return 'Create New Spot Market Client-Carrier Network';
    },
    saveNetworkBtnLabel() {
      if (this.isEdit) {
        return 'Save Changes';
      }

      /* istanbul ignore next */
      return 'Create Network';
    },
    pagingLength() {
      return Math.ceil(this.filtered.length / this.pageSize);
    },
  },
});
